import React__default from 'react';
import styled from 'styled-components';
import sx from '../../sx.js';
import { allIcons } from './fuegoicon.helpers.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Wrapper = styled.div.withConfig({
  displayName: "Fuegoicon__Wrapper",
  componentId: "sc-g8ymo5-0"
})(["width:var(--size);height:var(--size);& > svg{display:block;width:100%;height:100%;}", ""], sx);

/**
 *
 * @deprecated The Fuegoicon component is deprecated. Use icon components on their own as named imports from `@fuegokit/fuegicons-react` instead (e.g. `<Fuegoicon fuegoicon={akAlert} />` → `<AkAlertIcon />`)
 *
 * Fuegoicons are a set of functional, optimized, hand-crafted SVG icons,
 * created by the Appfire creative team for use across the product environment.
 *
 * To install the fuegoicons package in your application, use `npm install fuegoicons` or
 * `yarn add fuegoicons`, and pass the desired Fuegoicon id to the `<Fuegoicon>` component.
 */

const Fuegoicon = ({
  fuegoicon,
  size = 24,
  color,
  sx: sxProp,
  ariaLabel,
  ...delegated
}) => {
  // eslint-disable-next-line no-console
  console.warn('The <Fuegoicon> component has been removed. Install `@fuegokit/fuegoicons-react` and use named imports to import icon components on their own instead (e.g. <Fuegoicon fuegoicon={akAlert} /> → <AkAlertIcon />). The Fuegoicons base package has been removed as a direct dependency from Fuegokit React. The <Fuegoicon> component now renders a cancel icon and will be removed completely in September 2022.');
  const Component = allIcons[fuegoicon];
  return /*#__PURE__*/React__default.createElement(Wrapper, _extends({
    style: {
      '--size': `${size}px`
    },
    sx: sxProp
  }, delegated), /*#__PURE__*/React__default.createElement(Component, _extends({
    "aria-hidden": ariaLabel ? 'false' : 'true',
    "aria-label": ariaLabel,
    role: "img"
  }, delegated)));
};
Fuegoicon.displayName = "Fuegoicon";
/**
 * Fuegoicons are a set of functional, optimized, hand-crafted SVG icons,
 * created by the Appfire creative team for use across the product environment.
 *
 * To install the fuegoicons package in your application, use `npm install fuegoicons` or
 * `yarn add fuegoicons`, and pass the desired Fuegoicon id to the `<Fuegoicon>` component.
 */

// const Fuegoicon = styled(FuegoiconBase)<SxProp>`
//   ${({color, sx: sxProp}) => sx({sx: {color, ...sxProp}})}
// `

Fuegoicon.displayName = 'Fuegoicon';
var Fuegoicon$1 = Fuegoicon;

export { Fuegoicon$1 as default };
